define('plugin/user-license/view/UserLicenseDetailsView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * News details view
     *
     * @class NewsDetailsView
     */
    return LayoutView.extend({

        template: '#user_license_details_view',
        ui: {
            backBtn: '.js-history-back'
        },
        // Was href="javascript:void(0);" onclick="window.history.go(-1);" in the template --
        // both gated by CSP's script-src the same as inline <script> execution, with no nonce
        // mechanism to allow either (CY1SDEV1-3837 dropped 'unsafe-inline').
        events: {
            'click @ui.backBtn': 'onBackClick'
        },
        modelEvents: {
            'sync': 'render'
        },

        onBackClick: function (e) {
            e.preventDefault();
            window.history.go(-1);
        },

        serializeData: function () {
            var config = Config.getInstance();
            return _.extend(LayoutView.prototype.serializeData.apply(this, arguments), {
                company: config.getOption('company_data')
            });
        }

    });

});
